'use client'

import React, { useState, useEffect } from 'react'
import type { PaginationProps } from 'antd'
import { Pagination } from 'antd'
import { useRouter } from 'next/navigation'
import { buildSearchParamsToRoutePath } from '@/utils/index'
interface AntPaginationProps extends PaginationProps {
  lng: string
  type: string
  path: string
  current: number
  total: number
  pageSize?: number
  onChange?: (page: number, pageSize: number) => void
  currentParams?: Record<string, any> // 用于动态路由参数
}

const MyPagination: React.FC<AntPaginationProps> = ({ lng, type, path = '/', current, total, pageSize = 20, onChange, currentParams }) => {
  const router = useRouter()
  const itemRender: PaginationProps['itemRender'] = (_, type, originalElement) => {
    if (type === 'prev') {
      return <a className="text-[13px] sm:text-[14px]">{lng === 'en' ? 'PREVIOUS PAGE' : lng === 'zh-CN' ? '上一页' : '上一頁'}</a>
    }
    if (type === 'next') {
      return <a className="text-[13px] sm:text-[14px]">{lng === 'en' ? 'NEXT PAGE' : lng === 'zh-CN' ? '下一页' : '下一頁'}</a>
    }
    return originalElement
  }

  const handlePageChange = (page: number, pageSize: number) => {
    window.scrollTo({ top: 0 })
    // const newSearchParams = new URLSearchParams(searchParams)
    // newSearchParams.set('page', page.toString())
    // newSearchParams.toString() ：order=1&page=3
    // router.push(`/${lng}/${path}?${newSearchParams.toString()}`)
    const newParams = { ...currentParams, page: page }
    const newPath = buildSearchParamsToRoutePath(lng, path, newParams)
    router.push(newPath)
  }

  return (
    <div className="pagination-container">
      {type === 'server' ? (
        <Pagination responsive={true} showSizeChanger={false} current={current} pageSize={pageSize} total={total} onChange={handlePageChange} itemRender={itemRender as PaginationProps['itemRender']} />
      ) : (
        <Pagination responsive={true} showSizeChanger={false} current={current} pageSize={pageSize} total={total} onChange={onChange} itemRender={itemRender as PaginationProps['itemRender']} />
      )}
    </div>
  )
}

export default MyPagination
